<template>
  <div class="cropper" v-if="!isLoading">
    <span class="message"
      >Após selecionar a área para o recorte, clique na tesoura para
      finalizar.</span
    >
    <cropper
      ref="cropper"
      :defaultSize="defaultSize"
      :src="src"
      :stencil-props="{
        aspectRatio,
        handlers: {},
        movable: false,
        scalable: false,
      }"
      image-restriction="stencil"
      :stencil-component="stencil"
    ></cropper>

    <div class="container">
      <button @click="cancel" type="button" v-app-button>
        <b-icon size="is-small" icon="window-close"></b-icon>
      </button>
      <button @click="crop" type="button" v-app-button>
        <b-icon size="is-small" icon="content-cut"></b-icon>
      </button>
    </div>
  </div>
</template>

<script>
import { Cropper } from 'vue-advanced-cropper';

export default {
  name: 'app-image-cropper',
  components: { Cropper },
  model: {
    prop: 'model',
    event: 'cropped',
  },
  props: {
    src: String,
    aspectRatio: Number,
    height: Number,
    width: Number,
    stencil: String,
  },
  data() {
    return {
      isLoading: true,
      result: null,
    };
  },
  methods: {
    crop() {
      const { canvas } = this.$refs.cropper.getResult();
      this.setCroppedImage(canvas.toDataURL());
    },
    cancel() {
      this.src = '';
      this.setCroppedImage('');
    },
    setCroppedImage(base64) {
      this.$emit('croppedImage', base64);
      this.isLoading = true;
    },
    defaultSize() {
      return {
        width: this.width || 530,
        height: this.height || 370,
      };
    },
  },
  mounted() {
    this.isLoading = false;
    if (!this.stencil) this.stencil = 'rectangle-stencil';
  },
};
</script>

<style lang="scss" scoped>
.preview {
  border: dashed 1px rgba(255, 255, 255, 0.25);
}
.cropper {
  position: relative;
  width: calc(100% - 50px);
  max-height: 100%;
  margin-bottom: 15px;

  .message {
    font-style: italic;
    color: var(--color-danger);
    background: none;
  }

  .container {
    position: absolute;
    bottom: 0;
    left: -15px;
    button:first-child {
      background: var(--color-danger);
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    }

    button:last-child {
      background: var(--color-primary);

      margin-left: 5px;
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    }

    button:last-child:hover {
      background: var(--color-primary-light);
    }

    button:first-child:hover {
      background: #fc6e6ec9;
    }
  }
}
</style>
